import script from "./CategoriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesList.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesList.vue?vue&type=style&index=0&id=0f7ebe0a&lang=css"

const __exports__ = script;

export default __exports__